import React from "react";
import {
  Target,
  FileText,
  Sparkles,
  Wrench,
  Layers,
  ClipboardList,
  Box,
  Wallet,
  SlidersHorizontal,
} from "lucide-react";

const services = [
  {
    icon: Target,
    title: "Product Feasibility",
    desc: "Understand whether your concept is technically achievable.",
  },
  {
    icon: FileText,
    title: "Design Review",
    desc: "Review CAD models, drawings and product designs.",
  },
  {
    icon: Sparkles,
    title: "Design Improvement",
    desc: "Identify issues and recommend improvements.",
  },
  {
    icon: Wrench,
    title: "Design for Manufacturing",
    desc: "Make manufacturing easier, faster and cheaper.",
  },
  {
    icon: Layers,
    title: "Material Selection",
    desc: "Strength, weight, cost, temperature, durability, application.",
  },
  {
    icon: ClipboardList,
    title: "Process Selection",
    desc: "CNC \u00b7 3D Printing \u00b7 Injection Moulding \u00b7 Sheet Metal \u00b7 Casting \u00b7 PCB.",
  },
  {
    icon: Box,
    title: "Prototype Planning",
    desc: "A technical roadmap for building your prototype.",
  },
  {
    icon: Wallet,
    title: "Cost Optimisation",
    desc: "Reduce material, manufacturing, assembly and tooling cost.",
  },
  {
    icon: SlidersHorizontal,
    title: "Redesign",
    desc: "Improve performance, cost, weight, strength, manufacturability.",
  },
];

export default function Services() {
  return (
    <section className="w-full bg-[#faf6ee]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-24">
        {/* Eyebrow */}
        <p className="text-[11px] sm:text-xs tracking-[0.2em] font-semibold text-amber-500 uppercase mb-5">
          Services
        </p>

        {/* Headline */}
        <h2 className="font-serif text-[#111726] leading-[1.1] text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] max-w-3xl">
          Get expert guidance <span className="text-amber-500">before</span>{" "}
          you build.
        </h2>

        {/* Grid */}
        <div className="mt-12 sm:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {services.map(({ icon: Icon, title, desc }) => (
            <div
              key={title}
              className="rounded-2xl border border-black/10 bg-white p-6 sm:p-7 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200"
            >
              <Icon
                className="w-7 h-7 text-amber-500 mb-5"
                strokeWidth={1.75}
              />
              <h3 className="font-semibold text-[#111726] text-lg sm:text-xl mb-2">
                {title}
              </h3>
              <p className="text-slate-500 text-sm sm:text-base leading-relaxed">
                {desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}